/**
 * Dispatches a synthetic drag event on `element` for behavior tracking purposes.
 * Does nothing if the element is null or no longer attached to the DOM.
 * @param element - the drag handle.
 * @param type - whether a dragstart or dragend event needs to be dispatched.
 *
 * @internal
 */
export function dispatchDragTrackingEvent(
  element: HTMLElement | null,
  type: 'dragstart' | 'dragend',
): void {
  if (element === null || !element.isConnected) {
    return;
  }

  element.dispatchEvent(new DragEvent(type, { bubbles: true }));
}
